import React, { useContext } from 'react';
import { LanguageContext } from '../LanguageContext';

const About: React.FC = () => {
  const { t } = useContext(LanguageContext);

  const timeline = t?.about?.timelineItems || [];

  return (
    <section id="about" className="py-20 sm:py-32 bg-gray-50 dark:bg-gray-900/50 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <h2 className="text-3xl text-gray-900 dark:text-gray-50 font-bold tracking-tight sm:text-4xl">
            {t?.about?.title || ''}
          </h2>
          <p className="mt-4 max-w-4xl text-lg text-gray-600 dark:text-gray-400 lg:mx-auto">
            {t?.about?.description || ''}
          </p>
        </div>

        {/* Timeline */}
        <div className="mt-16 max-w-4xl mx-auto">
          <div className="space-y-12">
            {timeline.map((event: any, index: number) => (
              <div key={event?.title || index} className="flex items-start justify-between gap-6">
                <div className="flex items-center">
                  <span className="flex-shrink-0 h-8 w-8 rounded-full bg-accent text-white flex items-center justify-center mt-1">
                    <svg className="h-5 w-5 text-accent-foreground" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </span>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 dark:text-gray-50">{event?.title || ''}</h3>
                  <p className="mt-1 text-gray-600 dark:text-gray-400">{event?.description || ''}</p>
                </div>
                <p className="flex-shrink-0 text-gray-600 dark:text-gray-400 font-medium pt-1 whitespace-nowrap">{event?.year || ''}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
